<template>
  <div style="zoom: 0.9" class="manual_bill_wrapper">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Generate Credit Note</div>
      <div class="billDateText">
        Bill Date -&nbsp;&nbsp;
        {{ moment(creditNote.credit_note_date).format("DD MMM YYYY") }}
      </div>
    </div>
    <div class="white-wrapper" v-if="!creditNoteGenerated">
      <div class="row">
        <div class="col-6">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Cinema Name*</span>
            </div>
            <div class="col-9">
              <div class="dropdown-curve-container">
                <multiselect
                  :options="Cinemas"
                  v-model="selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_name"
                  placeholder="Select Cinema"
                  :preselect-first="true"
                  @select="onSelectCinema(null, $event)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Search Invoice*</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <multiselect
                  v-model="selectedInvoice"
                  id="ajax"
                  ref="searchInvoiceRef"
                  label="invoice_no"
                  track-by="invoice_no"
                  placeholder="Type to search invoice"
                  open-direction="bottom"
                  :options="searchInvoices"
                  :multiple="false"
                  :searchable="true"
                  :loading="isSearchLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :options-limit="300"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @select="onHandleSelectInvoices"
                  @search-change="onAsyncSearchInvoice"
                  select-label="Select"
                  deselect-label="Remove"
                >
                  <span slot="noResult">Oops! No Results found.</span>
                  <span slot="beforeList" v-if="isSearchLoading">
                    <div
                      class="p-3 text-center font-weight-bold d-flex align-items-center justify-content-center"
                    >
                      <b-spinner
                        small
                        variant="dark"
                        label="Spinning"
                        class="translate-spinner mr-2"
                      ></b-spinner
                      >Searching....
                    </div>
                  </span>
                  <span
                    slot="option"
                    slot-scope="props"
                    class="font-weight-bold"
                    >{{ props.option.invoice_no }}
                    <p
                      class="externalmovies text-muted"
                      v-if="props.option.type_name"
                    >
                      {{ props.option.type_name }}
                    </p>
                  </span>
                  <!-- <span class="externalmovies" v-if="props.option.suisa_id"></span> -->
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="invoiceAdded">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Customer Name</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="creditNote.customer_name"
                    type="text"
                    name="customer_name"
                    id="customer_name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="invoiceAdded">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Customer Address</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="creditNote.customer_address"
                    type="text"
                    name="customer_address"
                    id="customer_address"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="invoiceAdded">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Customer PAN</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="creditNote.customer_pan"
                    type="text"
                    name="customer_pan"
                    id="customer_pan"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="invoiceAdded">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Reason*</span>
            </div>
            <div class="col-9">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="creditNote['reason']"
                    type="text"
                    name="reason"
                    id="reason"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6" v-if="invoiceAdded">
          <div class="row align-items-center mb-2">
            <div class="col-3">
              <span class="font-weight-bold">Payment Mode*</span>
            </div>
            <div class="col-9">
              <div class="dropdown-curve-container">
                <multiselect
                  :options="paymentModes"
                  v-model="selectedPaymentMode"
                  :searchable="true"
                  label="pm_payment_mode"
                  track-by="pm_id"
                  placeholder="Select Payment Mode"
                  @select="onSelectPaymentMode(null, $event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <b-collapse
          v-model="collapseObj.item_array"
          class="pt-3 px-2 bor mb-4 back collapse show w-100"
        >
          <section class="row">
            <div class="w-100 mx-3 mb-3">
              <table
                class="swc-report-table"
                border="1"
                style="table-layout: auto; background: white"
              >
                <thead>
                  <tr>
                    <th class="bg-lightgrey p-1" style="width: 240px">Item</th>
                    <th class="bg-lightgrey p-1" style="width: 100px">QTY</th>
                    <th class="bg-lightgrey p-1" style="width: 100px"
                      >HS Code</th
                    >
                    <th
                      class="bg-lightgrey p-1"
                      style="width: 100px"
                      v-if="
                        creditNote['items_array'] &&
                          creditNote['items_array'].some(
                            (x) => x.hasOwnProperty('unit') && x.unit
                          )
                      "
                    >
                      Unit
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Unit Rate
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Net Rate
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Discount
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Final Unit Rate
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">
                      Final Net Rate
                    </th>
                    <th class="bg-lightgrey p-1" style="width: 125px">Tax</th>
                    <th class="bg-lightgrey p-1" style="width: 140px">
                      Gross Sum
                    </th>
                  </tr>
                </thead>
                <tbody v-if="creditNote['items_array'].length > 0">
                  <tr
                    v-for="(list, listKey) in creditNote['items_array']"
                    :key="listKey"
                    :class="errIndex == listKey ? 'errRow' : ''"
                    class="font-weight-bold fs-15 creditNoteRow"
                  >
                    <td class="text-left">
                      {{ list.item_name }}
                    </td>
                    <td class="text-right">
                      {{ list.qty }}&nbsp;<span v-if="list.qty_desc">{{
                        list.qty_desc
                      }}</span>
                    </td>
                    <td
                      class="text-left manual_bill_item"
                      style="padding: 0 !important;"
                    >
                      <div class="manual_bill_input">
                        <input
                          placeholder="Enter HS Code"
                          v-model="list.hs_code"
                          type="text"
                          :name="`hs_code_${listKey}`"
                          :id="`hs_code_${listKey}`"
                        />
                      </div>
                    </td>
                    <td class="text-left manual_bill_item" v-if="list.unit">
                      {{ list.unit }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          parseFloat(list.net_price_before_offer) /
                            parseInt(list.qty || 1)
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(list.net_price_before_offer) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(list.offer_price_net) }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          parseFloat(list.net_price) / parseInt(list.qty || 1)
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(parseFloat(list.net_price)) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(list.tax) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(list.gross_price) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="creditNote['items_array'].length > 0">
                  <tr>
                    <td
                      :colspan="
                        creditNote['items_array'] &&
                        creditNote['items_array'].some(
                          (x) => x.hasOwnProperty('unit') && x.unit
                        )
                          ? '9'
                          : '8'
                      "
                      class="borderNone"
                    ></td>
                    <td colspan="1" class="font-weight-bold text-left">Net</td>
                    <td colspan="1" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          creditNote["items_array"].reduce(
                            (acc, { net_price_before_offer }) =>
                              acc + parseFloat(net_price_before_offer || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :colspan="
                        creditNote['items_array'] &&
                        creditNote['items_array'].some(
                          (x) => x.hasOwnProperty('unit') && x.unit
                        )
                          ? '9'
                          : '8'
                      "
                      class="borderNone"
                    >
                      <div class="row">
                        <div class="col-2 text-left">
                          <span class="font-weight-bold">Sales Point:</span>
                        </div>
                        <div class="col-3 text-left">
                          <span>{{ creditNote.sales_point || "-" }}</span>
                        </div>
                      </div>
                    </td>
                    <td colspan="1" class="font-weight-bold text-left">
                      Discount
                    </td>
                    <td colspan="1" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          creditNote["items_array"].reduce(
                            (acc, { offer_price_net }) =>
                              acc + parseFloat(offer_price_net || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :colspan="
                        creditNote['items_array'] &&
                        creditNote['items_array'].some(
                          (x) => x.hasOwnProperty('unit') && x.unit
                        )
                          ? '9'
                          : '8'
                      "
                      class="borderNone"
                    >
                      <div class="row">
                        <div class="col-2 text-left">
                          <span class="font-weight-bold">Sales Person:</span>
                        </div>
                        <div class="col-3 text-left">
                          <span>{{ creditNote.sales_person || "-" }}</span>
                        </div>
                      </div>
                    </td>
                    <td colspan="1" class="font-weight-bold text-left">
                      Net Total
                    </td>
                    <td colspan="1" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          creditNote["items_array"].reduce(
                            (acc, { net_price }) =>
                              acc + parseFloat(net_price || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :colspan="
                        creditNote['items_array'] &&
                        creditNote['items_array'].some(
                          (x) => x.hasOwnProperty('unit') && x.unit
                        )
                          ? '9'
                          : '8'
                      "
                      class="borderNone"
                    >
                      <div class="row">
                        <div class="col-2 text-left">
                          <span class="font-weight-bold">Sales Date:</span>
                        </div>
                        <div class="col-3 text-left">
                          <span>{{ creditNote.org_invoice_date || "-" }}</span>
                        </div>
                      </div>
                    </td>
                    <td colspan="1" class="font-weight-bold text-left">
                      Tax Total
                    </td>
                    <td colspan="1" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          creditNote["items_array"].reduce(
                            (acc, { tax }) => acc + parseFloat(tax || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      :colspan="
                        creditNote['items_array'] &&
                        creditNote['items_array'].some(
                          (x) => x.hasOwnProperty('unit') && x.unit
                        )
                          ? '9'
                          : '8'
                      "
                      class="borderNone"
                    >
                      <div class="row">
                        <div class="col-2 text-left">
                          <span class="font-weight-bold">Payment Mode:</span>
                        </div>
                        <div class="col-3 text-left">
                          <span>{{ creditNote.org_payment_mode || "-" }}</span>
                        </div>
                      </div>
                    </td>
                    <td colspan="1" class="font-weight-bold text-left">
                      Gross Total
                    </td>
                    <td colspan="1" class="font-weight-bold text-right">
                      {{
                        currFormat(
                          creditNote["items_array"].reduce(
                            (acc, { gross_price }) =>
                              acc + parseFloat(gross_price || 0),
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="creditNote['items_array'].length == 0"
                style="background: white"
              >
                <div class="noInvoiceSelected" @click="ontoggleSearchInvoice">
                  <span>+ ADD INVOICE</span>
                </div>
              </div>
            </div>
          </section>
        </b-collapse>
      </div>

      <section v-if="invoiceAdded">
        <div class="row">
          <div class="mx-auto">
            <button
              :disabled="btenable"
              @click.prevent.stop="onGenerateCreditNote()"
              class="btn-blue"
            >
              {{ "Generate Credit Note" }}
            </button>
            <b-button
              @click.prevent.stop="resetHandler()"
              class="btn btn-black btn-default"
              variant="default"
              >{{ "Reset" }}</b-button
            >
            <b-button
              @click.prevent.stop="onCancel()"
              class="btn-outline-grey"
              variant="default"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </section>
    </div>
    <div class="white-wrapper" v-else>
      <div class="row">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="success-tick-wrapper">
            <span class="complete-tick">
              <img
                src="@/assets/img/icons/success-tick.svg"
                height="110"
                width="110"
                class="mr-2"
              />
            </span>
            <div class="refund-text font-weight-bold mb-3">
              Credit Note Generated.
            </div>
            <table
              class="swc-report-table mb-4"
              border="1"
              style="table-layout: auto; background: white"
            >
              <tbody v-if="creditNote['items_array'].length > 0">
                <tr>
                  <td class="font-weight-bold text-left">Net Total</td>
                  <td class="font-weight-bold text-right">
                    {{
                      currFormat(
                        creditNote["items_array"].reduce(
                          (acc, { net_price }) =>
                            acc + parseFloat(net_price || 0),
                          0
                        )
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold text-left">Tax Total</td>
                  <td class="font-weight-bold text-right">
                    {{
                      currFormat(
                        creditNote["items_array"].reduce(
                          (acc, { tax }) => acc + parseFloat(tax || 0),
                          0
                        )
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold text-left">Gross Total</td>
                  <td class="font-weight-bold text-right">
                    {{
                      currFormat(
                        creditNote["items_array"].reduce(
                          (acc, { gross_price }) =>
                            acc + parseFloat(gross_price || 0),
                          0
                        )
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button v-on:click="resetHandler()" class="btn-blue-lg">
            {{ $t("close") }}
          </button>
          <button v-on:click="onPrintHandler()" class="btn-blue-lg">
            {{ $t("Print") }}
          </button>
        </div>
      </div>
    </div>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <b-modal
      id="confirmStockDeduction"
      title="Do You Want To Stock In Items Again?"
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <div class="pb-1">
        <!-- <p class="fs-16 mb-4">{{ `` }}</p> -->
        <table class="table tableItem">
          <thead>
            <tr>
              <th scope="col" style="white-space: nowrap">Item Name</th>
              <th scope="col">Qty</th>
              <th scope="col" style="white-space: nowrap">Add to Stock</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, Itemindex) in creditNote['items_array']">
              <template>
                <tr :key="Itemindex">
                  <td>
                    {{ item.item_name }}
                  </td>
                  <td>{{ item.qty }}</td>
                  <td>
                    <div class="d-flex align-items-center mx-4">
                      <b-form-checkbox
                        v-model="item.reload_stock"
                        value="Y"
                        @change="
                          onChangeStockReload($event, 'item', Itemindex, null)
                        "
                        unchecked-value="N"
                        class="j-checkbox mb-1 pb-0"
                        name="check-button"
                      ></b-form-checkbox>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>

        <span class="mx-1"></span>
        <div class="text-center">
          <button
            class="btn btn-danger btn-danger-lg px-4 fs-14"
            @click.prevent.stop="onGenerateCreditNote(true)"
          >
            Proceed
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import CinemasService from "@/services/CinemasService";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import Printd from "printd";
  import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import moment from "moment";
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    components: { NoRecords },
    data() {
      return {
        selectedPaymentMode: null,
        invoiceAdded: false,
        isSearchLoading: false,
        searchInvoices: [],
        selectedInvoice: null,
        creditNoteId: null,
        creditNoteGenerated: false,
        EjsData: null,
        errIndex: null,
        Cinemas: [],
        Items: [],
        UomList: [],
        ChargeSettings: [],
        btenable: false,
        selectedCinema: "",
        cinema_id: null,
        submitted: false,
        collapseObj: {
          item_array: true,
        },
        creditNote: {
          cinema_id: null,
          cinema_name: "",
          customer_name: "",
          customer_address: "",
          customer_pan: "",
          ref_invoice_no: null,
          credit_note_no: null,
          reason: "",
          org_invoice_date: "",
          org_invoice_no: "",
          org_payment_mode: "",
          sales_person: "",
          sales_point: "",
          payment_mode_id: null,
          payment_mode: null,
          credit_note_date: new Date(),
          invoice_date: new Date(),
          type_id: null,
          type_name: null,
          otherInfo: null,
          invoice_type: null, //1 for ticket, 2 for fnb, 3 for manual bill
          items_array: [],
          booking_ref: null,
        },
      };
    },
    mounted() {},
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      this.getCinemaList(obj);
      this.fetchPaymentTypesList();
    },
    computed: {
      ...mapGetters(["getPaymentTypesList"]),
      paymentModes() {
        return this.getPaymentTypesList.filter((x) => x.pm_is_active == "Y");
      },
    },
    methods: {
      ...mapActions(["fetchPaymentTypesList"]),
      moment,
      onChangeStockReload(event, type, Itemindex, ci_index = null) {
        this.creditNote["items_array"][Itemindex].reload_stock = event;
      },
      onSelectPaymentMode(event, pm) {
        this.selectedPaymentMode = pm;
        this.creditNote["payment_mode_id"] = pm.pm_id;
        this.creditNote["payment_mode"] = pm.pm_payment_mode;
      },
      ontoggleSearchInvoice(event) {
        this.$refs.searchInvoiceRef.activate();
      },
      onHandleSelectInvoices(event) {
        this.selectedInvoice = event;
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.cinema_id,
          invoice_no: event["invoice_no"] || null,
          type: event["type"] || null,
          type_name: event["type_name"] || null,
          booking_ref: event["booking_ref"] || null,
        };
        CinemasService.GetInvoiceDetailsByID(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.creditNote) {
              console.log("Invoice Details", data.Records);
              this.creditNote["customer_name"] =
                data.creditNote["customer_name"];
              this.creditNote["customer_address"] =
                data.creditNote["customer_address"];
              this.creditNote["customer_pan"] = data.creditNote["customer_pan"];
              this.creditNote["org_payment_mode"] =
                data.creditNote["org_payment_mode"];
              this.creditNote["org_invoice_no"] =
                data.creditNote["org_invoice_no"];
              this.creditNote["org_invoice_date"] =
                data.creditNote["org_invoice_date"];
              this.creditNote["booking_ref"] = data.creditNote["booking_ref"];
              this.creditNote["sales_person"] = data.creditNote["sales_person"];
              this.creditNote["sales_point"] = data.creditNote["sales_point"];
              this.creditNote["type_id"] = data.creditNote["type_id"];
              this.creditNote["type_name"] = data.creditNote["type_name"];
              this.creditNote["ref_invoice_no"] =
                data.creditNote["org_invoice_no"];
              this.creditNote["otherInfo"] = data.creditNote["otherInfo"];
              this.creditNote["invoice_date"] = moment(
                data.creditNote["org_invoice_date"]
              ).format("YYYY-MM-DD HH:mm");
              this.creditNote["items_array"] =
                data.creditNote["creditNoteItems"];
              this.invoiceAdded = true;
            } else {
              this.invoiceAdded = false;
            }
          })
          .catch((error) => {
            console.log("Error:", error);
          })
          .finally(() => {
            loader.hide();
          });
      },
      onAsyncSearchInvoice: _.debounce(function(query) {
        if (!this.cinema_id) {
          return this.$toasted.show("Please Select Cinema");
        } else {
          if (query) {
            this.isSearchLoading = true;
            this.searchInvoices = [];
            CinemasService.GetValidInvoiceNumbers({
              cinema_id: this.cinema_id,
              searchValue: query,
            })
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  data.Records.map((x) => {
                    this.searchInvoices.push(x);
                  });
                }
              })
              .catch((error) => {
                console.log("on Async Search Invoice Error:", error);
              })
              .finally(() => {
                this.isSearchLoading = false;
              });
          }
        }
      }, 1.2 * 1000),
      validateCreditNote(showToast = true) {
        let errCount = 0;
        let errMsg = ``;
        console.log("creditNote", this.creditNote);

        if (!this.creditNote.cinema_id) {
          errCount++;
          this.errIndex = null;
          errMsg = `Please Select Cinema.`;
        } else if (!this.creditNote.credit_note_date) {
          errCount++;
          this.errIndex = null;
          errMsg = `Please Select Credit Note Date.`;
        } else if (!this.creditNote.type_id) {
          errCount++;
          this.errIndex = null;
          errMsg = `Invalid Request. TypeId Missing`;
        } else if (!this.creditNote.ref_invoice_no) {
          errCount++;
          this.errIndex = null;
          errMsg = `Invalid Request. Invoice Ref Missing`;
        } else if (!this.creditNote.reason) {
          errCount++;
          this.errIndex = null;
          errMsg = `Please Enter Reason.`;
        } else if (
          (this.creditNote.type_id == 1 || this.creditNote.type_id == 2) &&
          !this.creditNote.payment_mode_id
        ) {
          errCount++;
          this.errIndex = null;
          errMsg = `Please Enter Valid Payment Mode.`;
        } else if (
          !this.creditNote.items_array ||
          this.creditNote.items_array.length == 0
        ) {
          errCount++;
          this.errIndex = null;
          errMsg = `Please Select Items.`;
        } else if (this.creditNote.items_array.length > 0) {
          this.creditNote.items_array.forEach((item, itemIndex) => {
            if (errCount > 0) {
              return;
            } else {
              if (!item.item_name) {
                errCount++;
                this.errIndex = itemIndex;
                errMsg = `Item Name Required.`;
              } else if (!item.qty) {
                errCount++;
                this.errIndex = itemIndex;
                errMsg = `Please Enter Valid Quantity.`;
              }
            }
          });
        }

        if (errCount > 0) {
          if (showToast) {
            this.$toasted.show(errMsg);
          }
          return false;
        } else {
          return true;
        }
      },
      onCancel() {
        this.$router.replace({
          path: "/cinema-manager/credit-note",
        });
      },
      resetHandler() {
        this.creditNoteId = null;
        this.creditNoteGenerated = false;
        this.selectedPaymentMode = null;
        this.invoiceAdded = false;
        this.isSearchLoading = false;
        this.EjsData = null;
        this.errIndex = null;
        this.selectedCinema = "";
        this.cinema_id = null;
        this.submitted = false;
        this.creditNote = {
          cinema_id: null,
          cinema_name: "",
          customer_name: "",
          customer_address: "",
          customer_pan: "",
          ref_invoice_no: null,
          credit_note_no: null,
          reason: "",
          org_invoice_date: "",
          org_invoice_no: "",
          org_payment_mode: "",
          sales_person: "",
          sales_point: "",
          payment_mode_id: null,
          payment_mode: null,
          credit_note_date: new Date(),
          invoice_date: new Date(),
          type_id: null,
          type_name: null,
          otherInfo: null,
          invoice_type: null, //1 for ticket, 2 for fnb, 3 for manual bill
          items_array: [],
        };
        this.$forceUpdate();
      },
      onPrintHandler() {
        let payload = {
          isPrint: "Y",
          creditNoteId: this.creditNoteId,
        };
        let loader = this.$loading.show();
        CinemasService.GetCreditNoteDetails(payload)
          .then((response) => {
            if (response) {
              const { data } = response;
              if (data && data.hasOwnProperty("status") && !data.status) {
                this.$toasted.show(data.message || "Print Failed!");
              } else {
                this.EjsData = data;
                this.$nextTick(() => {
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });
              }
            }
          })
          .finally(() => {
            loader.hide();
          });
      },
      onGenerateCreditNote(confirmStock = false) {
        if (this.creditNote.type_id == 2 && !confirmStock) {
          this.$bvModal.show("confirmStockDeduction");
        } else if (this.validateCreditNote()) {
          this.$bvModal.hide("confirmStockDeduction");
          let payload = {
            creditNote: this.creditNote,
          };
          let loader = this.$loading.show();
          CinemasService.GenerateCreditNote(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);
                this.creditNoteId = data.creditNote_id;
                this.creditNoteGenerated = true;
                this.onPrintHandler();
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
            });
        }
      },
      getFloat(val = "0", fractionDigits = 8) {
        let parsed = parseFloat(String(val) || "0") || parseFloat("0");
        return parseFloat(parsed.toFixed(fractionDigits));
      },
      onSelectCinema(event, cinema) {
        this.selectedCinema = cinema;
        this.cinema_id = cinema.cine_id;
        this.creditNote["cinema_id"] = cinema.cine_id;
        this.creditNote["cinema_name"] = cinema.cine_name;
        //   this.getChargeSettingName(cinema.cine_id);
      },
      getCinemaList: function(cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.onSelectCinema(null, {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  });
                }
              });
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
    },
  };
</script>

<style>
  .noInvoiceSelected {
    border: 1px dashed;
    padding: 20px;
    margin: 20px;
    color: var(--lightgrey);
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .manual_bill_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .manual_bill_input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .manual_bill_input input::placeholder,
  .manual_bill_wrapper .multiselect__placeholder {
    font-size: 12px;
    font-style: italic;
  }

  .input_text-center input {
    text-align: center;
  }

  .input_text-right input {
    text-align: right;
  }

  .manual_bill_wrapper .multiselect__placeholder {
    font-weight: unset !important;
  }

  .noItemsClass {
    text-align: center;
    width: 100%;
    margin: 16px auto;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
  }

  .taxPopOver {
    zoom: 0.9;
    min-width: 200px;
  }

  .errRow {
    border: 2px solid red;
  }
  .borderNone {
    border: none !important;
  }

  .complete-tick {
    width: 120px;
    height: 120px;
    display: inline-block;
    background-size: contain;
  }
  .externalmovies {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 10px !important;
  }
  .billDateText {
    font-size: 17px;
    font-weight: 500;
  }

  .creditNoteRow td {
    padding: 10px 15px 10px 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CreditNoteComponents/AddCreditNote.vue